import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { notification } from "antd";
import MercadoPagoService from "../../sdk/services/MercadoPagoService";
import AuthService from "../auth/Authorization.service";
import DefaultLayout from "../layouts/default/Default.layout";
import { Plan, PlansPage, usePlans } from "../features/plans";
import { usePlanosVisitorProfile } from "../components/PublicChrome/freePlanosShell";
import PublicSiteFooter from "../components/PublicChrome/PublicSiteFooter";

const DOCUMENT_TITLE = "Planos e preços | Acertei Questões";

export default function PlanosPrecos() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const profile = usePlanosVisitorProfile(pathname);
  const { plans, loading, error } = usePlans();
  const [subscribingId, setSubscribingId] = useState<string | null>(null);

  useEffect(() => {
    document.title = DOCUMENT_TITLE;
  }, []);

  const handleSubscribe = async (plan: Plan) => {
    if (!AuthService.getAccessToken()) {
      navigate("/login");
      return;
    }
    if (!plan.productId) {
      notification.info({
        message: "Plano em breve",
        description: "Este plano ainda não está disponível para assinatura online. Fale com a gente pelo contato.",
      });
      return;
    }
    setSubscribingId(plan.id);
    try {
      const { init_point } = await MercadoPagoService.createCheckout(plan.productId);
      window.location.href = init_point;
    } catch (err: any) {
      notification.error({
        message: "Erro ao iniciar pagamento",
        description: err?.response?.data?.error || "Tente novamente.",
      });
    } finally {
      setSubscribingId(null);
    }
  };

  const content = (
    <PlansPage
      plans={plans}
      loading={loading}
      error={error}
      subscribingId={subscribingId}
      onSubscribe={handleSubscribe}
    />
  );

  if (profile === "free") {
    return createPortal(
      <div className="fixed inset-0 z-[9999] overflow-y-auto bg-canvas">
        <DefaultLayout hideNav>
          <div className="public-pages">
            {content}
            <PublicSiteFooter />
          </div>
        </DefaultLayout>
      </div>,
      document.body,
    );
  }

  return content;
}
